import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Online winkel',
        [PolygraphyProductUrlType.Storefront]: 'Winkelgevel',
        [PolygraphyProductUrlType.Custom]: 'Aangepast',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Sla wijzigingen op om het voorbeeld te zien',
  },
  buttons: {
    save_and_preview: 'Opslaan en voorbeeld bekijken',
  },
  toasts: {
    failed_to_load_data: 'Product laden mislukt',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt!',
    changes_got_saved: 'Wijzigingen opgeslagen!',
  },
};
